/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{clone as t}from"../../core/lang.js";class r{constructor(t){this._geometry=t}next(){const t=this._geometry;return this._geometry=null,t}}function e(r){return t(r)}export{r as SimpleGeometryCursor,e as clone};
